import React from 'react';
import { StarIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="w-full bg-navy-50/60 px-4 py-14 sm:py-20" data-id="element-239" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto w-full max-w-5xl" data-id="element-240" data-mp="3mepkmtrb3xrg">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-241" data-mp="3r7se71w3377n">
          Lo que ya están diciendo cientos de médicos
        </h2>

        <div className="mt-5 flex flex-col items-center gap-2" data-id="element-242" data-mp="421gir28q6aw">
          <div className="flex items-center gap-1" aria-hidden="true" data-id="element-243" data-mp="91w8yz1nz3y2">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-244" data-mp="e18w7kwg6d16" data-mpi={index} />)}
          </div>
          <p className="font-display text-xl font-black text-navy-900" data-id="element-245" data-mp="2avlofg728jx5">
            4.9/5
          </p>
          <p className="max-w-xl text-center text-[14px] leading-relaxed text-navy-800/75 sm:text-base" data-id="element-246" data-mp="1skj1s5i90nhs">
            Más de 2.000 profesionales ya utilizan Ruta Hipotiroidismo™ para
            tomar decisiones con mayor seguridad.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-247" data-mp="1iv99aojht2t5">
          {testimonials.map(testimonial => <li key={testimonial.name} className="rounded-3xl border border-navy-100 bg-white p-5 sm:p-6" data-id="element-248" data-mp="1euz5nij6aohg">
              <div className="flex items-center gap-3" data-id="element-249" data-mp="26jsjj9m3rpnv">
                <img src={testimonial.photo} alt={`Retrato de ${testimonial.name}`} loading="lazy" className="h-14 w-14 shrink-0 rounded-full object-cover" data-id="element-250" data-mp="26l3p9ez3z7hm" />
                <div className="min-w-0" data-id="element-251" data-mp="r438e5vy712t">
                  <p className="truncate font-display text-base font-bold text-navy-950" data-id="element-252" data-mp="r4v2tddt6sri">
                    {testimonial.name}
                  </p>
                  <p className="text-[12px] leading-snug text-navy-700/70 sm:text-sm" data-id="element-253" data-mp="nl4ecfx4j55a">
                    {testimonial.role}
                  </p>
                </div>
              </div>
              <div className="mt-3 flex items-center gap-0.5" aria-hidden="true" data-id="element-254" data-mp="el7v4tti6yhm">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-255" data-mp="ikyh8k834qft" data-mpi={index} />)}
              </div>
              <blockquote className="mt-3 text-[14px] leading-relaxed text-navy-900/85 sm:text-base" data-id="element-256" data-mp="9mwikbbtq9vp">
                “{testimonial.quote}”
              </blockquote>
            </li>)}
        </ul>

        <TransformCTA headline="Únete a los más de 2.000 médicos que ya decidieron dejar de dudar." data-id="element-257" data-mp="3w27l4xs2gkif" />
      </div>
    </section>;
}